import { render, staticRenderFns } from "./fullNameInRomanji.vue?vue&type=template&id=2e0c2c3a&scoped=true&"
import script from "./fullNameInRomanji.vue?vue&type=script&lang=js&"
export * from "./fullNameInRomanji.vue?vue&type=script&lang=js&"
import style0 from "./fullNameInRomanji.vue?vue&type=style&index=0&id=2e0c2c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c2c3a",
  null
  
)

export default component.exports